module.exports = __webpack_public_path__ + "img/state_1.b68298e2.jpg";